angular.module('mercury.modules.settings', [
  'mercury.modules.settings.billing',
  'mercury.modules.settings.company',
  'mercury.modules.settings.profile',
  'mercury.modules.settings.support'
]);
